import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getProductOfferingPrices } from 'app/entities/product-offering-price/product-offering-price.reducer';
import { TariffType } from 'app/shared/model/enumerations/tariff-type.model';
import { ProductType } from 'app/shared/model/enumerations/product-type.model';
import { createEntity, getEntity, reset, updateEntity } from './tariff.reducer';

export const TariffUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const productOfferingPrices = useAppSelector(state => state.productOfferingPrice.entities);
  const tariffEntity = useAppSelector(state => state.tariff.entity);
  const loading = useAppSelector(state => state.tariff.loading);
  const updating = useAppSelector(state => state.tariff.updating);
  const updateSuccess = useAppSelector(state => state.tariff.updateSuccess);
  const tariffTypeValues = Object.keys(TariffType);
  const productTypeValues = Object.keys(ProductType);

  const handleClose = () => {
    navigate('/tariff');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getProductOfferingPrices({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...tariffEntity,
      ...values,
      productOfferingPrices: mapIdList(values.productOfferingPrices),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          type: 'DELIVERY_COST_GAS',
          productType: 'ELECTRICITY',
          ...tariffEntity,
          productOfferingPrices: tariffEntity?.productOfferingPrices?.map(e => e.id.toString()),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="crawlerBackendApp.tariff.home.createOrEditLabel" data-cy="TariffCreateUpdateHeading">
            <Translate contentKey="crawlerBackendApp.tariff.home.createOrEditLabel">Create or edit a Tariff</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tariff-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.tariff.type')}
                id="tariff-type"
                name="type"
                data-cy="type"
                type="select"
              >
                {tariffTypeValues.map(tariffType => (
                  <option value={tariffType} key={tariffType}>
                    {translate(`crawlerBackendApp.TariffType.${tariffType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.tariff.productType')}
                id="tariff-productType"
                name="productType"
                data-cy="productType"
                type="select"
              >
                {productTypeValues.map(productType => (
                  <option value={productType} key={productType}>
                    {translate(`crawlerBackendApp.ProductType.${productType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.tariff.isFixedTariff')}
                id="tariff-isFixedTariff"
                name="isFixedTariff"
                data-cy="isFixedTariff"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.tariff.productOfferingPrice')}
                id="tariff-productOfferingPrice"
                data-cy="productOfferingPrice"
                type="select"
                multiple
                name="productOfferingPrices"
              >
                <option value="" key="0" />
                {productOfferingPrices
                  ? productOfferingPrices.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tariff" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TariffUpdate;
